import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

// A cada acesso (sessão) verifica se há ao menos 1 feriado; se não houver, avisa.
export function FeriadosAlerta({ ativo, empresaId }) {
  const [aberto, setAberto] = useState(false);
  useEffect(() => {
    const ok = `digiponto_feriados_ok_${empresaId}`, aviso = `digiponto_feriados_aviso_${empresaId}`;
    if (!ativo || sessionStorage.getItem(ok) === "1") return;
    api.get("/feriados").then((r) => {
      const d = r.data;
      const n = Array.isArray(d) ? d.length : (d?.gerais?.length || 0) + (d?.especificos?.length || 0) + (d?.items?.length || 0);
      if (n > 0) sessionStorage.setItem(ok, "1");
      else if (sessionStorage.getItem(aviso) !== "1") {
        sessionStorage.setItem(aviso, "1");
        setAberto(true);
      }
    }).catch(() => {});
  }, [ativo, empresaId]);
  return (
    <AlertDialog open={aberto} onOpenChange={setAberto}>
      <AlertDialogContent data-testid="feriados-alerta">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-amber-700">Atenção!</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-700">Preencher os feriados.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction data-testid="feriados-alerta-ok">OK</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
